import React, { useEffect, useState } from "react";
import Footer from "../../../common/Footer";
import { getSiteContent } from "../../../services/operations/siteContentApi";

const renderContent = (content) => content.split(/\r?\n/).map((line, index) => {
  const text = line.replace(/^#{1,3}\s+/, "");
  if (/^#\s+/.test(line)) return <h1 key={index}>{text}</h1>;
  if (/^##+\s+/.test(line)) return <h2 key={index}>{text}</h2>;
  if (/^[-*]\s+/.test(line)) return <li key={index}>{line.replace(/^[-*]\s+/, "")}</li>;
  return line.trim() ? <p key={index}>{line}</p> : <br key={index} />;
});

export default function ManagedPolicyPage({ contentKey, fallback }) {
  const [content, setContent] = useState(null);
  useEffect(() => { getSiteContent(contentKey).then(setContent); }, [contentKey]);
  if (!content) return fallback;
  return <><main className="managed-policy"><article>{renderContent(String(content))}</article></main><Footer /></>;
}
